const firebaseConfig = {
    apiKey: "AIzaSyDVuveoSRUYfSQZ9HdEhP5MHoxqkWShVLI",
    authDomain: "lamborghini-wheels.firebaseapp.com",
    projectId: "lamborghini-wheels",
    storageBucket: "lamborghini-wheels.appspot.com",
    messagingSenderId: "14855680502",
    appId: "1:14855680502:web:564cff496d56b491c297d7"
};

export default firebaseConfig